/* @flow */

import * as React from 'react';
import { assertNumber } from '@e180/util/lib/assert';

export default function usePeriodicRender(interval: number) {
  assertNumber(interval, 'interval');

  const intervalRef = React.useRef();
  const [counter, setCounter] = React.useState(0);

  React.useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setCounter((prevCounter) => prevCounter + 1);
    }, interval * 1000);

    return () => {
      const { current: id } = intervalRef;

      if (id) {
        window.clearInterval(id);
      }
    };
  }, []);

  return counter;
}
